import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'safe',
    standalone: true // Fondamentale per usarlo direttamente nei tuoi componenti standalone!
})
export class SafePipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }

    transform(url: string): SafeResourceUrl {
        // Diciamo ad Angular che questo URL è sicuro per essere usato come "Resource" (es. iframe)
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}